import React from 'react';
import PropTypes from 'prop-types';
import {
    Table, TableContainer, TableHead, TableRow,
    TableCell, TableBody, Typography, withStyles
} from "@material-ui/core";
import moment from "moment-timezone";
import guid from './../../../../utils/guid';
import NoData from './../../../Common/NoDataRow';
import useStyles from "./tabStyles";
import { calcDurationFromEpoch } from './../../../../utils/helpers';
import t from "../../../../languages/pl";
import { displayDateTimeFormat } from './../../../../utils/staticData';

const RouteTab = props => {
    const { classes, routes } = props;

    const generateRouteDetailsTable = data => {
        if (!data || data.length === 0)
            return <NoData colSpan={9} />;
        return data.map(row => {
            let duration = calcDurationFromEpoch(row.data_od, row.data_do);
            return (
                <TableRow key={guid()}>
                    <TableCell className={classes.tableCell}>
                        <Typography variant="body1">
                            {moment.unix(row.data_od).format(displayDateTimeFormat)}
                        </Typography>
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                        <Typography variant="body1">
                            {moment.unix(row.data_do).format(displayDateTimeFormat)}
                        </Typography>
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                        <Typography variant="body1">
                            {row.kierowca}
                        </Typography>
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                        <Typography variant="body1">
                            {row.dystans}
                        </Typography>
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                        <Typography variant="body1">
                            {row.stan_paliwa}&nbsp;({Math.round(row.stan_paliwa_procent*100)})
                        </Typography>
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                        <Typography variant="body1">
                            {row.predkosc_max}
                        </Typography>
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                        <Typography variant="body1">
                            {row.predkosc_sr}
                        </Typography>
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                        <Typography variant="body1">
                            {duration.get("hours") > 0 ? duration.get("hours") + t.hoursAbbreviation : ''}
                            &nbsp;
                            {duration.get("minutes")}{t.minutesAbbreviation}
                        </Typography>
                    </TableCell>
                </TableRow>
            );
        });
    };

    return (
        <TableContainer className={classes.tableContainer}>
            <Table stickyHeader>
                <TableHead>
                    <TableRow >
                        <TableCell className={classes.tableCell}>
                            <Typography variant="body1">
                                {t.dateFrom}
                        </Typography>
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                            <Typography variant="body1">
                                {t.dateTo}
                        </Typography>
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                            <Typography variant="body1">
                                {t.driver}
                        </Typography>
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                            <Typography variant="body1">
                                {t.distance} [km]
                        </Typography>
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                            <Typography variant="body1">
                                {t.fuelLevel} [l (%)]
                        </Typography>
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                            <Typography variant="body1">
                                {t.speed}<br />{t.max.toLowerCase()}<br />[km/h]
                        </Typography>
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                            <Typography variant="body1">
                                {t.speed}<br />{t.average.toLowerCase()}<br />[km/h]
                        </Typography>
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                            <Typography variant="body1">
                                {t.timeBehindTheWheel}
                        </Typography>
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {generateRouteDetailsTable(routes)}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

RouteTab.propTypes = {
    classes: PropTypes.object,
    routes: PropTypes.array
};

export default withStyles(useStyles)(RouteTab);
